module.exports = __webpack_public_path__ + "static/media/11A.35615297.png";